








































































import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';

import { useQuery } from '@vue/apollo-composable';

import ChartWithLastYearCompare from '@/components/Report/ChartWithLastYearCompare.vue';
import ChartWithSelectedMonth from '@/components/Report/ChartWithSelectedMonth.vue';
import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';
import TreemapAreaFailedProduct from '@/components/Report/05-UnsuccessCost/5.2-UnsuccessProduct/TreemapAreaFailedProduct.vue';
import DonutHubFailedProduct from '@/components/Report/05-UnsuccessCost/5.2-UnsuccessProduct/DonutHubFailedProduct.vue';

import overallExpense from '@/gql/managementReport/02-Expense/overallExpense.gql';
import monthFailedDeliveryPackagePrice from '@/gql/managementReport/05-UnsuccessCost/5.2-FailedDeliveryProductCost/monthFailedDeliveryPackagePrice.gql';
import failedDeliveryPackagePrice from '@/gql/managementReport/05-UnsuccessCost/5.2-FailedDeliveryProductCost/failedDeliveryPackagePrice.gql';
import failedDeliveryPackagePriceRange from '@/gql/managementReport/05-UnsuccessCost/5.2-FailedDeliveryProductCost/failedDeliveryPackagePriceRange.gql';
import failedDeliveryPackagePriceByHub from '@/gql/managementReport/05-UnsuccessCost/5.2-FailedDeliveryProductCost/failedDeliveryPackagePriceByHub.gql';
import failedDeliveryPackagePriceByArea from '@/gql/managementReport/05-UnsuccessCost/5.2-FailedDeliveryProductCost/failedDeliveryPackagePriceByArea.gql';

const UnsuccessDeliveryProductCost = defineComponent({
  components: {
    SmallChartPanel,
    ChartWithLastYearCompare,
    ChartWithSelectedMonth,
    DonutHubFailedProduct,
    TreemapAreaFailedProduct,
  },
  setup() {
    const primaryColor = 'rgba(173,81,0,1)';
    const secondaryColor = 'rgba(255,131,3,1)';

    const { result: getTopInfo } = useQuery(failedDeliveryPackagePrice, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeY1: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.failedDeliveryPackagePrice || {});
    const getPanelInfoMtd = computed(() => getTopInfo.value?.failedDeliveryPackagePriceMTD || {});

    return {
      primaryColor,
      secondaryColor,
      overallExpense,
      monthFailedDeliveryPackagePrice,
      failedDeliveryPackagePriceRange,
      failedDeliveryPackagePriceByHub,
      failedDeliveryPackagePriceByArea,
      failedDeliveryPackagePrice,

      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default UnsuccessDeliveryProductCost;
